'use client'
import { PrismicImage, PrismicRichText } from "@prismicio/react";
import React, { useState } from "react";

/**
 * @typedef {import("@prismicio/client").Content.FunctioningConceptSlice} FunctioningConceptSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<FunctioningConceptSlice>} FunctioningConceptProps
 * @param {FunctioningConceptProps}
 */

const FunctioningConceptItem = ({ card, index }) => {

  const [isOpen, setIsOpen] = useState(false);
  function toggle() {
    setIsOpen(!isOpen);
  }
  return <React.Fragment>
    <div className={`functioning-element w-full md:w-[310px] mt-10 md:mt-16 md:mb-30px ${index < 3 ? 'self-end' : 'self-start'}`}>
      <div className="w-full flex justify-end" >
        <PrismicImage
          className="w-full h-[230px] md:h-[270px] md:w-[270px] rounded-tr-[100px] md:rounded-tr-[0px] object-cover"
          loading="lazy"
          field={card.picture} />
      </div>
      <div className="relative rounded-b-30px rounded-b-30px md:rounded-30px relative bg-white py-5 px-6 -mt-30px">
        <div className="flex flex-col items-stretch w-full">
          <div className="w-full flex flex-row justify-between toggle-btn" onClick={toggle}>
            <PrismicRichText field={card.title} />
            <div className="mt-2  md:hidden ">
              <div className={`spin_arrow h-2 w-4 ${isOpen ? 'toggle-active' : ''}`}>
                <img width={16} height={8} src='/svg/arrow-faq.svg'  className="w-full h-auto" loading="lazy"/>
              </div>
            </div>
          </div>

          <div className={`${isOpen ? '' : 'hidden'} md:block mt-2.5`}>
            <PrismicRichText field={card.text} />
          </div>
        </div>
        <div className="absolute z-20 round left-0 -top-[225px] md:-left-[25px] md:-top-[25px]">
          {index + 1}
        </div>
      </div>
    </div>
  </React.Fragment>
}


const FunctioningConcept = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-white bg-grain ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>

      <div className="pt-10 pb-12 md:py-20 px-4">
        <div className="flex flex-col content-center justify-items-center">
          <div className="h2-like text-left md:text-center pb-6 md:pb-30px mr-5 md:mr-0">
            <PrismicRichText field={slice.primary.title} />
          </div>
          <div className="flex flex-row justify-center">
            <div className="max-w-[530px] text-left md:text-center text-highlight">
              <PrismicRichText field={slice.primary.text} />
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-center">
          <div className="flex flex-row content-start justify-center flex-wrap max-w-[1400px] md:gap-x-14 lg:gap-x-[124px]">
            {
              slice.primary.cards.map((card, i) => {
                return <FunctioningConceptItem key={i} card={card} index={i}></FunctioningConceptItem>
              })
            }
          </div>
        </div>
      </div>
    </section>
  );
};

export default FunctioningConcept;
